import { memo } from 'react'

interface IImageIconProps {
  size?: number
  className?: string
}

const ImageIcon: React.FC<IImageIconProps> = memo(({ size = 16, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_2104_12217)">
        <rect x="1" y="4" width="13.93" height="9" fill="black" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.06689 1.6C1.06689 1.17565 1.23547 0.768687 1.53552 0.468629C1.83558 0.168571 2.24255 0 2.66689 0L11.421 0L14.9336 3.51253V10.9781L12.2669 8.3072L9.11063 11.4613L4.80023 6.08L1.06689 10.7467V1.6ZM11.7336 6.4H10.6669V5.33333H11.7336V6.4Z"
          fill="currentColor"
        />
        <path
          d="M1.06689 12.4548V14.4004C1.06689 14.8248 1.23547 15.2318 1.53552 15.5318C1.83558 15.8319 2.24255 16.0004 2.66689 16.0004H13.3336C13.7579 16.0004 14.1649 15.8319 14.4649 15.5318C14.765 15.2318 14.9336 14.8248 14.9336 14.4004V12.4879L12.2669 9.81698L9.02316 13.0586L4.80023 7.78711L1.06689 12.4548Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2104_12217">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
})

ImageIcon.displayName = 'ImageIcon'

export { ImageIcon }
